module.exports = {
  title: 'Animated Text Count with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2023-07-05',
  slug: 'animated-count-text',
  tags: ['reanimated'],
};
